module.exports = __webpack_public_path__ + "img/head_icon1.png";